<template>
  <div>
    <el-alert
      title="计件：金额 = 合格数量 × 工序计件单价 − 不良数量 × 不良扣款。不良不计入合格工资；扣款为 0 时不良只是不计。计时仍按定额或打卡工时 × 小时费率。单价在工序档案维护。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-date-picker v-model="query.dateFrom" type="date" value-format="yyyy-MM-dd" placeholder="日期从" style="width:140px" />
      <el-date-picker v-model="query.dateTo" type="date" value-format="yyyy-MM-dd" placeholder="到" style="width:140px" />
      <el-select v-model="query.settleMode" style="width:130px">
        <el-option label="计件" value="PIECE" />
        <el-option label="优先打卡" value="AUTO" />
        <el-option label="仅打卡" value="CLOCK" />
        <el-option label="仅定额" value="NORM" />
      </el-select>
      <el-select v-model="query.groupBy" style="width:120px">
        <el-option label="按员工" value="staff" />
        <el-option label="按工单" value="order" />
        <el-option label="明细" value="detail" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button icon="el-icon-download" :disabled="!list.length" @click="exportCsv">导出</el-button>
    </div>
    <div v-if="summary" style="margin-bottom:10px;color:#606266;font-size:13px">
      产出合计 <b>{{ summary.totalQtyOut }}</b>
      · 报废 <b>{{ summary.totalQtyScrap }}</b>
      · 结算工时 <b>{{ summary.totalNormHours }}</b>
      · 其中打卡 <b>{{ summary.totalClockHours }}</b>
      · 金额 <b style="color:#E6A23C">{{ summary.totalAmount }}</b>
    </div>
    <el-table :data="list" border v-loading="loading" show-summary :summary-method="tableSummary">
      <el-table-column v-if="query.groupBy !== 'order'" prop="staffNumber" label="员工编码" width="110" />
      <el-table-column v-if="query.groupBy !== 'order'" prop="staffName" label="员工" width="110" />
      <el-table-column v-if="query.groupBy !== 'staff'" prop="orderCode" label="工单编号" width="140" />
      <el-table-column v-if="query.groupBy === 'detail'" prop="orderName" label="工单名称" min-width="120" show-overflow-tooltip />
      <el-table-column v-if="query.groupBy === 'detail'" prop="operationName" label="工序" width="120" />
      <el-table-column v-if="query.groupBy === 'detail'" prop="reportDate" label="日期" width="110" />
      <el-table-column v-if="query.groupBy !== 'detail'" prop="trackingCount" label="笔数" width="80" align="right" />
      <el-table-column prop="qtyOut" label="产出" width="100" align="right" />
      <el-table-column prop="qtyScrap" label="报废" width="90" align="right" />
      <el-table-column prop="normHours" label="结算工时" width="110" align="right" />
      <el-table-column label="来源" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.hourSource" size="mini" :type="sourceType(row.hourSource)">
            {{ sourceText(row.hourSource) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="query.settleMode !== 'PIECE'" prop="laborHourlyCost" label="费率" width="90" align="right" />
      <el-table-column v-if="query.settleMode === 'PIECE' && query.groupBy === 'detail'" prop="piecePrice" label="计件单价" width="100" align="right" />
      <el-table-column v-if="query.settleMode === 'PIECE' && query.groupBy === 'detail'" prop="scrapDeductPrice" label="不良扣款" width="100" align="right" />
      <el-table-column prop="amount" label="金额" width="110" align="right" />
    </el-table>
  </div>
</template>

<script>
import { listLaborSettle } from '../../api/laborSettle'

export default {
  name: 'LaborSettlePage',
  data() {
    return {
      query: { groupBy: 'staff', settleMode: 'PIECE', dateFrom: '', dateTo: '' },
      list: [], summary: null, loading: false
    }
  },
  created() { this.load() },
  methods: {
    load() {
      this.loading = true
      listLaborSettle(this.query).then(res => {
        const result = res.data || {}
        this.summary = result
        this.list = result.rows || []
      }).finally(() => { this.loading = false })
    },
    sourceText(s) {
      if (s === 'CLOCK') return '打卡'
      if (s === 'MIXED') return '混合'
      if (s === 'PIECE') return '计件'
      return '定额'
    },
    sourceType(s) {
      if (s === 'CLOCK') return 'success'
      if (s === 'MIXED') return 'warning'
      if (s === 'PIECE') return ''
      return 'info'
    },
    exportCsv() {
      const piece = this.query.settleMode === 'PIECE'
      const detail = this.query.groupBy === 'detail'
      const byOrder = this.query.groupBy === 'order'
      const cols = []
      if (!byOrder) cols.push(['员工编码', 'staffNumber'], ['员工', 'staffName'])
      if (this.query.groupBy !== 'staff') cols.push(['工单编号', 'orderCode'])
      if (detail) cols.push(['工单名称', 'orderName'], ['工序', 'operationName'], ['日期', 'reportDate'])
      if (!detail) cols.push(['笔数', 'trackingCount'])
      cols.push(['产出', 'qtyOut'], ['报废', 'qtyScrap'], ['结算工时', 'normHours'], ['来源', 'hourSource'])
      if (!piece) cols.push(['费率', 'laborHourlyCost'])
      if (piece && detail) cols.push(['计件单价', 'piecePrice'], ['不良扣款', 'scrapDeductPrice'])
      cols.push(['金额', 'amount'])
      const lines = [cols.map(c => c[0]).join(',')]
      this.list.forEach(row => {
        lines.push(cols.map(c => {
          let v = row[c[1]]
          if (c[1] === 'hourSource') v = this.sourceText(v)
          const text = v == null ? '' : String(v)
          return '"' + text.replace(/"/g, '""') + '"'
        }).join(','))
      })
      const blob = new Blob(['\uFEFF' + lines.join('\n')], { type: 'text/csv;charset=utf-8' })
      const a = document.createElement('a')
      a.href = URL.createObjectURL(blob)
      a.download = '工资结算.csv'
      a.click()
      URL.revokeObjectURL(a.href)
    },
    tableSummary({ columns, data }) {
      const sums = []
      columns.forEach((col, i) => {
        if (i === 0) { sums[i] = '合计'; return }
        if (['qtyOut', 'qtyScrap', 'normHours', 'amount', 'trackingCount'].indexOf(col.property) >= 0) {
          const v = data.reduce((t, r) => t + (Number(r[col.property]) || 0), 0)
          sums[i] = Math.round(v * 10000) / 10000
        } else {
          sums[i] = ''
        }
      })
      return sums
    }
  }
}
</script>
